module.exports = __webpack_public_path__ + "media/body-condition/regular-a26f5470.svg";